import script from "./purchaser-summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchaser-summary.vue?vue&type=script&setup=true&lang=ts"

import "./purchaser-summary.vue?vue&type=style&index=0&id=137cf7a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137cf7a8"]])

export default __exports__